<div class="grid grid-cols-[72px_minmax(0,1fr)] gap-x-2.5 gap-y-2 items-start">
  <span class="text-body-2 text-neutral-60 pt-2">{{ 'actionsInbox.email.to' | translate }}</span>
  <span class="text-body-2 text-neutral-90 pt-2 flex items-center gap-2 min-w-0 [overflow-wrap:anywhere]">
    @if (showAvatar()) {
      <span class="avatar avatar-xs bg-inserv-10">{{ draft().to | nameInitials }}</span>
    }
    {{ draft().to }}
    <span class="text-neutral-60">&lt;{{ draft().toEmail }}&gt;</span>
  </span>

  <span class="text-body-2 text-neutral-60 pt-2">{{ 'actionsInbox.email.subject' | translate }}</span>
  <kendo-textbox
    [value]="draft().subject"
    [readonly]="!canEditSubject()"
    (valueChange)="subjectChange.emit($event ?? '')"
  ></kendo-textbox>

  <span class="text-body-2 text-neutral-60 pt-2">{{ 'actionsInbox.email.body' | translate }}</span>
  <kendo-textarea
    [value]="draft().body"
    [rows]="rows()"
    [readonly]="!canEditBody()"
    (valueChange)="bodyChange.emit($event ?? '')"
  ></kendo-textarea>
</div>
